import React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, List, Typography, Progress, Avatar, Space, Empty, Button } from "antd";
import { ApartmentOutlined, TeamOutlined } from "@ant-design/icons";
import AllTrainings from "PlatForms/OrgLMS/Hooks/useTrainingList";

const { Text } = Typography;

const AllTrainingsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { darkMode = false } = location.state || {};
  const { enrolledTrainings, loading } = AllTrainings();

  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    avatarIcon: {
      backgroundColor: darkMode ? "#2a2a2a" : "#f0f0f0",
      color: darkMode ? "#ffffff" : "#1890ff",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: "16px",
      borderTop: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
      marginTop: "auto",
    },
  };

  return (
    <Card
      loading={loading}
      title={
        <Space style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={styles.cardTitle}>
            <TeamOutlined style={{ marginRight: 8 }} />
            Trainings
          </span>
        </Space>
      }
      style={{ ...styles.card, ...styles.trainingCard }}
      headStyle={styles.cardTitle}
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {enrolledTrainings.length === 0 ? (
        <Empty description="No Trainings Assigned Yet" />
      ) : (
        <>
          <List
            itemLayout="horizontal"
            dataSource={enrolledTrainings}
            renderItem={(training) => {
              const listItem = (
                <div style={{ position: "relative" }}>
                  {training.isRetryTraining && <div className="ribbon-Badge">Repeated</div>}
                  <List.Item
                    style={{
                      backgroundColor: darkMode ? "#2a2a2a" : "#fff",
                      borderColor: darkMode ? "#404040" : "#f0f0f0",
                      transition: "all 0.3s",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = darkMode ? "#2a2a2a" : "#f5f5f5";
                      e.currentTarget.style.transform = "translateX(4px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = darkMode ? "#2a2a2a" : "#fff";
                      e.currentTarget.style.transform = "translateX(0)";
                    }}
                    onClick={() =>
                      navigate("/mentor/learners-by-training", {
                        state: { trainingId: training.id, darkMode },
                      })
                    }
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar
                          icon={<ApartmentOutlined />}
                          style={{ ...styles.avatarIcon, transition: "all 0.3s ease" }}
                        />
                      }
                      title={
                        <Text strong style={{ ...styles.textColor, transition: "all 0.3s ease" }}>
                          {training.title}
                        </Text>
                      }
                      description={
                        <>
                          <Progress
                            percent={training.progress}
                            size="small"
                            strokeColor={darkMode ? "#ffffff" : "#1890ff"}
                            format={(percent) => (
                              <span style={{ color: darkMode ? "#ffffff" : "#000000" }}>
                                {percent}% complete
                              </span>
                            )}
                          />
                          <Text style={styles.secondaryTextColor}>
                            Group Name: {training.groupName}
                          </Text>
                        </>
                      }
                    />
                  </List.Item>
                </div>
              );

              return listItem;
            }}
          />
        </>
      )}
    </Card>
  );
};

AllTrainingsList.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  trainings: PropTypes.array,
};

export default AllTrainingsList;
